import { render, staticRenderFns } from "./CreateNewBonus.vue?vue&type=template&id=ce37746a&scoped=true&"
import script from "./CreateNewBonus.vue?vue&type=script&lang=js&"
export * from "./CreateNewBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce37746a",
  null
  
)

export default component.exports